import {
    // Constants
    UPDATE_CREATIVES,
    UPDATE_MOTD,
    UPDATE_NEWS,
    UPDATE_VERSIONS,

    // Actions
    updateHash,

    // Selectors
    getUiVersion,
    getCreativesTimeStamp,
    getNewsTimeStamp,
    getMotdLatestTimeStamp,
} from '../data'
import { actions, constants } from '../imports'

const SyncMiddleware = store => next => (action) => {
    switch (action.type) {
        // Update the sync file when serverlist changes
        case constants.SERVERLIST_CHANGED: {
            const result = next(action)
            store.dispatch(updateHash())
            return result
        }

        // Update news when there are new news
        case UPDATE_NEWS: {
            const oldHash = getNewsTimeStamp(store.getState())
            const result = next(action)
            const newHash = getNewsTimeStamp(store.getState())
            if (oldHash !== newHash) {
                store.dispatch(actions.newsOutdated())
            }
            return result
        }

        // Update ads when there are new ads
        case UPDATE_CREATIVES: {
            const oldTimestamp = getCreativesTimeStamp(store.getState())
            const result = next(action)
            const newTimestamp = getCreativesTimeStamp(store.getState())
            if (oldTimestamp !== newTimestamp) {
                store.dispatch(actions.creativesOutdated())
            }
            return result
        }

        // Update motd when there is a new motd
        case UPDATE_MOTD: {
            const oldTimestamp = getMotdLatestTimeStamp(store.getState())
            const result = next(action)
            const newTimestamp = getMotdLatestTimeStamp(store.getState())
            if (oldTimestamp !== newTimestamp) {
                store.dispatch(actions.motdOutdated(newTimestamp))
            }
            return result
        }

        // Log when version changes
        case UPDATE_VERSIONS: {
            // Get the current UI versions
            const prevUiVersion = getUiVersion(store.getState())
            const result = next(action)
            const nextUiVersion = getUiVersion(store.getState())

            if (nextUiVersion !== '-1' && prevUiVersion !== nextUiVersion) {
                store.dispatch(actions.log(`Detected UI version ${nextUiVersion}`))
            }

            return result
        }

        default:
            return next(action)
    }
}

export default SyncMiddleware



// WEBPACK FOOTER //
// ./src/features/Sync/middleware/index.js